import config from '@iotv/config';
import { DailyDecadePeriodizer, HourlyYearPeriodizer, QuarterHourPeriodizer } from '@iotv/datamodel-core';
import { AccumulatorClasses, PeriodizerClasses } from '@iotv/iotv-v3-types';
import { getObjectFromS3, s3PutWithCors } from '../api/s3';
const debug = process.env.REACT_APP_DEBUG && false;
/**
 * THESE ARE GET FUNCTIONS FROM @IOTV/DATASTORE WHICH APP SHOULD NOT ACCESS. IAM ROLES DEFINED IN COGNITO STACK LIMIT TO READ ONLY HENCE NO PUTS
 */
const bucketIdentifier = config.aws.s3.largeObjects.Name;
/**
 * **UI-only!**
 *
 * Special UI-only accessor to handle limited permissions
 *
 * The identically-named functions from `@iotv/datastore` **will not** work in the UI!
 */
export const getDehydratedPeriodizer = async (vob, className) => {
    let res = { err: null, data: null };
    const Key = `${className}:${vob.sk}`;
    res = await getObjectFromS3({ Key, bucketIdentifier });
    debug && console.log('getDehydratedPeriodizer,', res, bucketIdentifier);
    return res;
};
/**
 * **UI-only!**
 *
 * Special UI-only accessor to handle limited permissions
 *
 * The identically-named functions from `@iotv/datastore` **will not** work in the UI!
 */
export const getQuarterHourPeriodizer = async (vob) => {
    let res = { err: null, data: null };
    const className = PeriodizerClasses.QuarterHourPeriodizer;
    const getRes = await getDehydratedPeriodizer(vob, className);
    debug && console.log('getRes', getRes, vob);
    if (getRes.data) {
        const periodizerFromIngestion = new QuarterHourPeriodizer();
        periodizerFromIngestion.ingest(getRes.data);
        res.data = periodizerFromIngestion;
    }
    else {
        res.err = getRes.err;
    }
    return res;
};
/**
 * **UI-only!**
 *
 * Special UI-only accessor to handle limited permissions
 *
 * The identically-named functions from `@iotv/datastore` **will not** work in the UI!
 */
export const getHourlyYearPeriodizer = async (vob) => {
    let res = { err: null, data: null };
    const className = PeriodizerClasses.HourlyYearPeriodizer;
    const getRes = await getDehydratedPeriodizer(vob, className);
    if (getRes.data) {
        const periodizerFromIngestion = new HourlyYearPeriodizer();
        periodizerFromIngestion.ingest(getRes.data);
        res.data = periodizerFromIngestion;
    }
    else {
        res.err = getRes.err;
    }
    return res;
};
/**
 * **UI-only!**
 *
 * Special UI-only accessor to handle limited permissions
 *
 * The identically-named functions from `@iotv/datastore` **will not** work in the UI!
 */
export const getDailyDecadePeriodizer = async (vob) => {
    let res = { err: null, data: null };
    const className = PeriodizerClasses.DailyDecadePeriodizer;
    const getRes = await getDehydratedPeriodizer(vob, className);
    if (getRes.data) {
        const periodizerFromIngestion = new DailyDecadePeriodizer();
        periodizerFromIngestion.ingest(getRes.data);
        res.data = periodizerFromIngestion;
    }
    else {
        res.err = getRes.err;
    }
    return res;
};
/**
 * **UI-only!**
 *
 * Special UI-only accessor to handle limited permissions
 *
 * The identically-named functions from `@iotv/datastore` **will not** work in the UI!
 */
export const getDehydratedAccumulator = async (vob, className) => {
    let res = { err: null, data: null };
    const Key = `${className}:${vob.sk}`;
    if (className === AccumulatorClasses.HourlyYearBasedNormalAccumulator) {
        res = await getObjectFromS3({ Key, bucketIdentifier });
    }
    return res;
};
/**
 * **UI-only!**
 *
 * Special UI-only accessor to handle limited permissions
 *
 * The identically-named functions from `@iotv/datastore` **will not** work in the UI!
 */
export const putDehydratedAccumulator = async (dehydrated, className) => {
    let res = { err: null, data: null };
    const Key = `${className}:${dehydrated.sk}`;
    //console.log(Key)
    if (className === AccumulatorClasses.HourlyYearBasedNormalAccumulator) {
        res = await s3PutWithCors(Key, bucketIdentifier, dehydrated);
    }
    else {
        res.err = new Error("Can't put accumulator other than HourlyYearBasedNormalAccumulator");
    }
    return res;
};
